import { addGetVersionToWindow } from "@payair/e-com-common-sdk/core/BaseEcomSdk";
import { SrciSdkImpl } from "./core/SrciSdk";
import { SrciButtonColorEnumsObj } from "./enums/SrciButtonColorEnum";
import { SrciButtonSizeEnumsObj } from "./enums/SrciButtonSizeEnum";
import { SrciEventListenerEnumsObj } from "./enums/SrciEventListenerEnum";
import { SrciEventTypeEnumsObj } from "./enums/SrciEventTypeEnum";
/** @internal */ var MAIN_OBJECT_NAME = "payairSrci";
/** @internal */ var SDK_OBJECT_NAME = "srciSdk";
var srciSdk = new SrciSdkImpl();
/*
  NOTE
  Added getVersion to window always. If user uses JS file, the object will be overwritten with proper getVersion,
  otherwise if using NPM this object will stay in the window object.
*/
/** @internal */ addGetVersionToWindow(MAIN_OBJECT_NAME, SDK_OBJECT_NAME, srciSdk.getVersion);
var payairSrci = {
    srciSdk: srciSdk,
    SrciEventListenerEnums: SrciEventListenerEnumsObj,
    SrciEventTypeEnums: SrciEventTypeEnumsObj,
    SrciButtonColorEnums: SrciButtonColorEnumsObj,
    SrciButtonSizeEnums: SrciButtonSizeEnumsObj,
};
export default payairSrci;
